import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import 'app-template-lib/dist/style.css'; //先にライブラリのスタイルを適用
import './index.css'; //このプロジェクトのスタイルで上書き

ReactDOM.createRoot(document.getElementById('root')!).render(
    // React Router v5 では、React.StrictMode でpush等が動作しないため、コメントアウト
    // <React.StrictMode>
    <App />
);
